export default "__VITE_ASSET__wjGNC5Xb__"